import React, { useEffect, useState } from "react";
import { DiscountRow, Product, Variant } from "../../types.ts";

import { styled } from 'styled-components';
import { getPeriodNumberFromLabel } from "../../../../../misc/helpers.ts";
import { useAppTranslation } from "../../../../../translations/useAppTranslation.ts";
import { ProductCardVisibility } from "../../../../types.ts";

const ProductCardContainer = styled.div`

  font-size: 16px;

  .variants {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;

    .variant {
      border-radius: 50px;
      display: inline-block;
      padding: 0 8px;
      background: var(--Valkoinen, #fff);
      border: 2px solid var(--Lumme, #004107);
      color: var(--Lumme);
      font-weight: 700;

      &:focus-within {
        outline: 2px solid var(--Lumme);
      }
    }

    input[type="radio"] {
      background-color: var(--Valkoinen, #fff);
      appearance: none;
      opacity: 0;
      position: absolute;
      height: 6px;
      width: 6px;
      top: 3px;
      border-color: var(--Valkoinen, #fff);
      box-shadow: none;
    }

    input[type="radio"]:checked {
      background-color: var(--Lumme);
    }

    input[type="radio"]::before {
      width: 6px;
      height: 6px;
      background-color: var(--Valkoinen, #fff);
    }

    input[type="radio"]:checked:before {
      width: 6px;
      height: 6px;
      background-color: var(--Lumme, #004107);
    }

    .selected {
      background: var(--Lumme, #004107);
      color: var(--Valkoinen, #fff);
    }


  }

  &.horizontal {
    flex: 1 0 100%;
    gap: 0;

    .variants {
      padding-bottom: 6px;
    }

    @media only screen and (min-width: 992px) {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;
        /* padding: 28px; */
        column-gap: 120px;

        .title {
          flex: 1 0 calc(100% - 32px);
          order: 1;
          margin-bottom: 16px;
        }

        .tags {
          flex: 1 1 380px;
          order: 2;
        }

        .variants {
          flex: 1 1 200px;
          margin: 0;
          order: 3;
          padding-bottom: 0;
        }

        .description {
          flex: 1 1 380px;
          margin-top: 1.2rem;
        }

        .left {
          flex: 1 1 380px;
          order: 4;
        }

        .right {
          align-items: flex-start;
          flex: 1 1 200px;
          order: 5;
        }

        .price-main {
          margin: 0;
        }

        button {
          margin: 2rem 0 0 0;
          z-index: 2;
        }

        .image {
          bottom: -60%;
          right: 15%;
          transform: scale(240%);

          @media only screen and (min-width: 992px) {
            bottom: -80%;
          }
        }
      }
  }
  min-width: 280px;
  flex: 1 0 260px;
  background-color: ${props => props.color};
  border-radius: 8px;
  padding: 16px;
  color: #000;

  display: flex;
  flex-direction: column;
  gap: 16px;

  position: relative;
  overflow: hidden;

  *:not(svg) {
    position: relative;
    z-index: 2;
  }

  h3 {
    margin: 0;
  }

  ul {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;
  }

  .variant {
    border-radius: 50px;
    display: inline-block;
    padding: 6px 8px;
    background: var(--Valkoinen, #fff);
    border: 2px solid var(--Lumme, #004107);
    color: var(--Lumme);
    font-weight: 700;
    margin-bottom: 0;

    &:hover {
      cursor: pointer;
    }

    &.selected {
      background: var(--Lumme, #004107);
      color: var(--Valkoinen, #fff);
    }

    span {
      line-height: 2;
    }


  }

  .right {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: flex-end;
  }

  .tag {
    background: hsla(0,0%,100%,.5);
    border-radius: 50px;
    display: inline-block;
    list-style: none;
    margin-bottom: 6px;
    padding: 6px 16px;
    display: flex;
    align-items: center;
    gap: 6px;

    img {
      height: 22px;
    }
  }

  .description {
    padding-left: 20px;
  }

  .campaign-text {
    margin-bottom: 20px;
    padding-left: 30px;

    &::before {
      content: url("data:image/svg+xml,%3Csvg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2.95723 4.69988C2.95723 4.23796 3.14073 3.79496 3.46736 3.46833C3.79398 3.14171 4.23698 2.95821 4.6989 2.95821H5.49057C5.95045 2.95795 6.39155 2.77581 6.71765 2.45154L7.27182 1.89738C7.43367 1.73461 7.6261 1.60544 7.83805 1.5173C8.05 1.42916 8.27728 1.38379 8.50682 1.38379C8.73636 1.38379 8.96364 1.42916 9.17558 1.5173C9.38753 1.60544 9.57996 1.73461 9.74182 1.89738L10.296 2.45154C10.6222 2.77613 11.0639 2.95821 11.5231 2.95821H12.3147C12.7767 2.95821 13.2197 3.14171 13.5463 3.46833C13.8729 3.79496 14.0564 4.23796 14.0564 4.69988V5.49154C14.0564 5.95071 14.2385 6.39246 14.5631 6.71863L15.1172 7.27279C15.28 7.43465 15.4092 7.62708 15.4973 7.83903C15.5854 8.05097 15.6308 8.27825 15.6308 8.50779C15.6308 8.73734 15.5854 8.96461 15.4973 9.17656C15.4092 9.38851 15.28 9.58094 15.1172 9.74279L14.5631 10.297C14.2388 10.6231 14.0567 11.0642 14.0564 11.524V12.3157C14.0564 12.7776 13.8729 13.2206 13.5463 13.5473C13.2197 13.8739 12.7767 14.0574 12.3147 14.0574H11.5231C11.0632 14.0576 10.6221 14.2398 10.296 14.564L9.74182 15.1182C9.57996 15.281 9.38753 15.4101 9.17558 15.4983C8.96364 15.5864 8.73636 15.6318 8.50682 15.6318C8.27728 15.6318 8.05 15.5864 7.83805 15.4983C7.6261 15.4101 7.43367 15.281 7.27182 15.1182L6.71765 14.564C6.39155 14.2398 5.95045 14.0576 5.49057 14.0574H4.6989C4.23698 14.0574 3.79398 13.8739 3.46736 13.5473C3.14073 13.2206 2.95723 12.7776 2.95723 12.3157V11.524C2.95697 11.0642 2.77484 10.6231 2.45057 10.297L1.8964 9.74279C1.73363 9.58094 1.60447 9.38851 1.51633 9.17656C1.42819 8.96461 1.38281 8.73734 1.38281 8.50779C1.38281 8.27825 1.42819 8.05097 1.51633 7.83903C1.60447 7.62708 1.73363 7.43465 1.8964 7.27279L2.45057 6.71863C2.77484 6.39253 2.95697 5.95142 2.95723 5.49154V4.69988Z' fill='%23004107'/%3E%3Cpath d='M6.125 8.49984L7.70833 10.0832L10.875 6.9165' fill='%23004107'/%3E%3Cpath d='M6.125 8.49984L7.70833 10.0832L10.875 6.9165' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
      position: absolute;
      top: 0.5rem;
      left: 0;
    }
  }

  .price-base {
    border-top: 1px solid var(--Valkoinen, #fff);
    padding-top: 20px;
    margin-top: 20px;;
    span {
      font-weight: 600;
    }
  }

  .price-main {
    font-family: itc-benguiat,serif;
    font-size: 28px;
    font-weight: 700;
    margin-top: 15px;

    span {
      font-size: 16px;
    }
  }

  .image {
    bottom: -15%;
    position: absolute;
    right: -33%;
    transform: scale(140%);
    z-index: 1;
  }

  button {
    margin-top: auto;
    z-index: 2;
    padding: 10px 50px;

    &.primary.purple {
      background-color: var(--Ametisti, #6A2C91);
      color: var(--Valkoinen, #fff);
      border: 2px solid var(--Ametisti, #6A2C91);

      &:hover {
        opacity: 0.9;
      }
    }
  }

  .title {
    color: #000;
    font-family: itc-benguiat,serif;
    font-size: 2rem;
    font-weight: 700;

    z-index: 10;
  }

  .note {
    padding-bottom: 10px;
    font-size: 14px;
  }

  .read-more {
    text-align: center;
    margin-top: 10px;
    font-weight: 700
  }
  .actions {
    display: flex;
    flex-direction: column;
  }
`;

interface B2CProductsProps {
  product: Product;
  horizontal?: boolean;
  consumption?: number;
  includeVAT?: boolean;
  buttonLink?: string;
  buttonText?: string;
  discountRows: DiscountRow[];
  variantLink?: boolean;
  visibility?: ProductCardVisibility;
  preSelectedVariantId?: string;
  handleClick: (selectedVariant: Variant) => void;
}

function ProductCard(props: B2CProductsProps) {
  const { product, horizontal = false, consumption, handleClick, includeVAT = true, discountRows, buttonLink, buttonText, variantLink, preSelectedVariantId, visibility } = props;

  const { t, db_t, i18n } = useAppTranslation();
  const [currentLanguage] = useState(i18n.language);

  const [availableVariants] = useState(product.variants.filter(variant => variant.is_available === 1 && variant.is_hidden === 0));
  const [selectedVariant, setSelectedVariant] = useState(availableVariants.find(variant => variant.contract_template_id === preSelectedVariantId) ?? availableVariants[0]);
  const [tags] = useState(product.tags?.filter(tag => tag.is_visible === 1));
  const [energyName, setEnergyName] = useState('Energiamaksu');
  const [prices, setPrices] = useState({ priceKWH: '', priceMonthly: '', monthlyPrice: '', dailyPrice: '' });
  const [discountRow, setDiscountRow] = useState<DiscountRow | undefined>(undefined);
  const [contractPeriod, setContractPeriod] = useState<number | undefined>(getPeriodNumberFromLabel(selectedVariant.contract_period.label));

  useEffect(() => {
    const priceKWH = selectedVariant.name.includes('rssis') ? selectedVariant.energy_price + 8.82 : selectedVariant.energy_price;
    const priceMonthly = selectedVariant.monthly_price;

    const { priceMonth, priceConsumption } = handleVAT(includeVAT, parseFloat(selectedVariant.vat.label), priceMonthly, priceKWH);

    // ((consumption * priceKWH / 100) + (priceMonthly * 12))
    const yearPrice = ((consumption ?? 0) * priceConsumption / 100) + (priceMonth * 12);
    const monthlyPrice = yearPrice / 12;
    const dailyPrice = yearPrice / 365;

    setPrices({
      priceKWH: selectedVariant.energy_price.toLocaleString('fi-FI'),
      priceMonthly: priceMonthly.toLocaleString('fi-FI'),
      monthlyPrice: roundPrice(monthlyPrice).toLocaleString('fi-FI'),
      dailyPrice: roundPrice(dailyPrice).toLocaleString('fi-FI'),
    });
  }, [selectedVariant]);

  function roundPrice(price: number) {
    return Math.round(price * 100) / 100;
  }

  function handleVAT(includeVAT: boolean, vatBase: number, priceMonth: number, priceKWH: number) {
    if (typeof vatBase == 'undefined' || vatBase == null) {
      vatBase = 0.255;
    }
    const vatMultiplier = vatBase != 0 ? 1 + vatBase / 100 : 1.255;

    if (includeVAT && vatBase == 0) {
      priceMonth = priceMonth ? priceMonth * vatMultiplier : 0;
      priceKWH = priceKWH ? priceKWH * vatMultiplier : 0;
    } else if (!includeVAT && vatBase != 0) {
      priceMonth = priceMonth ? priceMonth / vatMultiplier : 0;
      priceKWH = priceKWH ? priceKWH / vatMultiplier : 0;
    }
    return { priceMonth, priceConsumption: priceKWH };
  }


  const handleVariantClick = (variant: Variant) => {
    setSelectedVariant(variant);
  }

  const handleCtaClick = () => {
    if (selectedVariant) {
      handleClick(selectedVariant);
    }
  }

  useEffect(() => {
    let name = 'common.energyPrice';
    if (selectedVariant.name.includes('rssis')) {
      name = 'common.margin';
    } else if (selectedVariant.name.includes('ynergia')) {
      name = 'common.priceForecast';
    }
    setEnergyName(name);
    setDiscountRow(discountRows.find(row => row.productId === selectedVariant.hs_id));
    setContractPeriod(getPeriodNumberFromLabel(selectedVariant.contract_period.label));
  }, [selectedVariant]);

  return (
    <>
      <ProductCardContainer className={horizontal ? 'horizontal' : undefined} key={product.hs_id} color={product.background_color}>
        <div className="title"> {db_t(product, 'name')}</div>
        <div className="variants">
          {availableVariants.map((variation) => (
            <label key={variation.hs_id} className={'variant' + (selectedVariant.contract_template_id === variation.contract_template_id ? ' selected' : '')}>
              <input
                type="radio"
                name={"variant" + product.hs_id + (horizontal ? 'horizontal' : '')}
                value={variation.contract_template_id}
                checked={selectedVariant.contract_template_id === variation.contract_template_id}
                onChange={() => handleVariantClick(variation)}
              />
              <span>{t('common.' + variation.contract_period.label)}</span>
            </label>
          ))}
        </div>
        <ul className="tags">
          {tags.map((tag) => (
            <li className="tag" key={tag.hs_id}>
              {tag.icon && <img src={tag.icon.url} alt={tag.icon.altText} />}
              <span>{db_t(tag, 'name')}</span>
            </li>
          ))}
        </ul>
        <div className="left">
          {visibility?.show_description != false && <div className="description" dangerouslySetInnerHTML={{ __html: db_t(selectedVariant, 'description') }}></div>}

          {visibility?.show_prices != false && <div className="price-base">
            {(visibility?.show_campaign != false && selectedVariant.campaign_text) && <div className="campaign-text" dangerouslySetInnerHTML={{ __html: db_t(selectedVariant, 'campaign_text') }}></div>}
            {!consumption && <div className="price-main">{selectedVariant.name.includes('rssis') ? 'SPOT + ' + prices.priceKWH : prices.priceKWH} <span> {t('common.c/kWh')}</span></div>}
             <div>{t('common.monthlyPrice')}: <span>{(discountRow && (contractPeriod == null || discountRow.duration <= contractPeriod)) ? '0' : prices.priceMonthly } {t('common.€/month')}</span></div>
            {(discountRow) && <div>({(contractPeriod == undefined || discountRow.duration < contractPeriod) && t('phaseTwo.firstMonths', {duration: discountRow.duration})}{t('common.normally')} {prices.priceMonthly}{t('common.€/month')})</div>}
            {consumption && <div>{t(energyName)}: <span>{prices.priceKWH} {t('common.c/kWh')}</span></div>}
          </div>}
          {!consumption && <div className="note">{t('phaseTwo.vatText', { vat: selectedVariant.vat.label})}</div>}
        </div>

        <div className="right">
          {(consumption && visibility?.show_prices != false) && (<>
            <div className="price-main">{prices.monthlyPrice} <span>{t('common.€/month')}</span></div>
            {/* <div>{variant.dailyPrice} € / päivä</div> */}
            <div className="note">* {t('phaseTwo.estimatePrice')}</div>
            <div className="note">{t('phaseTwo.vatText', { vat: selectedVariant.vat.label})}</div>
          </>)}
            {/* <div className="actions"> */}
              {visibility?.show_cta_button != false && <>
                {buttonLink
                  ? <a href={!variantLink ? buttonLink : `${buttonLink}?contract=${selectedVariant.contract_template_id}${currentLanguage === 'en' ? '&lang=en' : ''}`} className="lumme-button primary purple" target="_blank" rel="noopener noreferrer">{buttonText ? buttonText : t('phaseTwo.cta')}</a>
                  : <button type="button" className="lumme-button primary" onClick={handleCtaClick}>{buttonText ? buttonText : t('phaseTwo.cta')}</button>
                }
              </>}
              {visibility?.show_product_page_link === true && <a className="read-more" href={selectedVariant.product_page_link} target="_blank" rel="noreferrer">{t('phaseTwo.readMore')}</a>}
            {/* </div> */}
        </div>

        <svg className="image" width="345" height="336" viewBox="0 0 345 336" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M193.291 128.891C201.083 117.705 208.548 106.26 216.78 95.4172C222.965 87.2741 230.097 79.8515 236.902 72.1911C240.759 67.8557 245.433 67.6338 250.664 69.5935C271.74 77.5024 283.791 93.2099 288.98 114.476C297.04 147.519 290.327 178.916 276.82 209.15C264.277 237.243 246.135 261.133 219.512 277.332C184.928 298.382 149.28 297.277 113.474 280.365C92.0254 270.24 73.4004 256.449 60.7758 235.948C46.8916 213.402 43.4673 188.627 50.0095 163.341C64.3977 107.778 97.2643 67.2999 151.226 45.6647C166.006 39.7331 181.46 39.5549 196.789 45.4075C202.789 47.6983 205.2 51.3848 204.239 57.3664C200.777 78.9757 197.186 100.567 193.629 122.159C193.272 124.317 192.835 126.461 192.441 128.613C192.725 128.706 193.008 128.799 193.291 128.891Z" fill="#FFFFFF" style={{ fillOpacity: '.25' }} />
        </svg>

      </ProductCardContainer>
    </>
  )
}

export default ProductCard;
